import appConfig from 'src/utils/appConfig';
import interpolate from 'src/utils/interpolate';

let translationFile;
const { locale } = appConfig.getMyConfig();

// private; loads content asynchronously (testing)
const fetchTranslationFile = async (locale) => {
  const { default: translationFile } =
    await import(/* webpackChunkName: "locales/[request]"*/ `locales/${locale}.json`);
  return translationFile;
};

export const loadTranslationFile = async () => {
  translationFile = await fetchTranslationFile(locale);
};

export const translate = (key, { hash } = {}) => {
  const splitKey = key.split('.');
  let value = translationFile;
  splitKey.forEach((partialKey) => {
    if (value.hasOwnProperty(partialKey)) {
      value = value[partialKey];
    } else {
      throw new Error(`Missing translation for "${key}" with locale "${locale}"`);
    }
  });
  return interpolate(value, hash);
};

